"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('controllers/authenticationController',["require", "exports", "jquery", "providers/ajaxSettingsProvider", "controllers/abortingRequest"], function (require, exports, $, ajaxSettingsProvider, abortingRequest) {
    "use strict";

    var AuthenticationController = function () {
        function AuthenticationController() {
            _classCallCheck(this, AuthenticationController);

            this.baseRoute = '/api/Account/';
        }

        _createClass(AuthenticationController, [{
            key: "getManageInfo",
            value: function getManageInfo() {
                var generateState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

                //var deferred = $.Deferred();
                var route = this.baseRoute + 'ManageInfo' + this.urlQueryString('/', generateState);
                return abortingRequest.send(route, ajaxSettingsProvider.httpGet(), false, false);
                /*var options = ajaxSettingsProvider.httpGet();
                      options.refreshTokePromise.then(function (newAccessToken) {
                          if (newAccessToken) {
                        options.settings.headers.Authorization = 'Bearer ' + newAccessToken;
                    }
                          $.ajax(route, options.settings).then((result) => {
                        deferred.resolve(result);
                    });
                          
                });
                      //return $.ajax(route, ajaxSettingsProvider.httpGet().settings);
                      return deferred.promise();*/
            }
        }, {
            key: "getUserInfo",
            value: function getUserInfo() {
                var route = this.baseRoute + 'UserInfo';
                return abortingRequest.send(route, ajaxSettingsProvider.httpGet());
                //return $.ajax(route, ajaxSettingsProvider.httpGet(accessToken ? ajaxSettingsProvider.createAuthHeader(accessToken) : undefined));
            }
        }, {
            key: "getPolicyHolderInfo",
            value: function getPolicyHolderInfo(accessToken) {
                var route = this.baseRoute + 'GetPolicyHolderInfo';
                return abortingRequest.send(route, ajaxSettingsProvider.httpGet());
                //return $.ajax(route, ajaxSettingsProvider.httpGet(accessToken ? ajaxSettingsProvider.createAuthHeader(accessToken) : undefined));
            }
        }, {
            key: "addExternalLogin",
            value: function addExternalLogin(data) {
                var route = this.baseRoute + 'AddExternalLogin';
                return $.ajax(route, ajaxSettingsProvider.httpPost(data).settings);
            }
        }, {
            key: "urlQueryString",
            value: function urlQueryString(returnUrl, generateState) {
                return '?returnUrl=' + encodeURIComponent(returnUrl) + '&generateState=' + (generateState ? 'true' : 'false');
            }
        }, {
            key: "login",
            value: function login(data) {
                return $.ajax(this.baseRoute + 'Login', ajaxSettingsProvider.httpPost(data, null).settings);
            }
        }, {
            key: "twoFactor",
            value: function twoFactor(data) {
                return $.ajax(this.baseRoute + 'TwoFactor', ajaxSettingsProvider.httpPost(data, null).settings);
            }
        }, {
            key: "recoveryCode",
            value: function recoveryCode(data) {
                return $.ajax(this.baseRoute + 'RecoveryCode', ajaxSettingsProvider.httpPost(data, null).settings);
            }
        }, {
            key: "logout",
            value: function logout() {
                var route = this.baseRoute + 'Logout';
                return $.ajax(route, ajaxSettingsProvider.httpPost({}).settings);
            }
        }, {
            key: "changePassword",
            value: function changePassword(data) {
                var route = this.baseRoute + 'changePassword';
                return abortingRequest.send(route, ajaxSettingsProvider.httpPost(data));
                //return $.ajax(route, ajaxSettingsProvider.httpPost(data).settings);
            }
        }, {
            key: "resetRecoveryCodes",
            value: function resetRecoveryCodes() {
                var route = this.baseRoute + 'resetRecoveryCodes';
                return abortingRequest.send(route, ajaxSettingsProvider.httpPost());
            }
        }, {
            key: "resetAuthenticatorApp",
            value: function resetAuthenticatorApp() {
                var route = this.baseRoute + 'resetAuthenticatorApp';
                return abortingRequest.send(route, ajaxSettingsProvider.httpPost());
            }
        }, {
            key: "setupAuthenticatorApp",
            value: function setupAuthenticatorApp() {
                var route = this.baseRoute + 'setupAuthenticatorApp';
                return abortingRequest.send(route, ajaxSettingsProvider.httpPost());
            }
        }, {
            key: "setPassword",
            value: function setPassword(data) {
                var route = this.baseRoute + 'setPassword';
                return $.ajax(route, ajaxSettingsProvider.httpPost(data).settings);
            }
        }]);

        return AuthenticationController;
    }();

    return new AuthenticationController();
});
//# sourceMappingURL=authenticationController.js.map;
